import store from '@/store';

export default {
  isSpain() {
    return store.state.apiSelected.code === 'es';
  },
  isChile() {
    return store.state.apiSelected.code === 'cl';
  },
  showInvoices() {
    return this.isSpain() || this.isChile();
  }
};



// WEBPACK FOOTER //
// ./src/services/utilService.js